import React, { useMemo } from 'react';
import { BankAccountModel } from '../../constants';
import { maskIBAN } from './utils';
import PropTypes from 'prop-types';
import classes from './AccountNumber.module.scss';

export const AccountNumber = ({ data }) => {
    const text = useMemo(() => {
        switch (data.account_type) {
            case BankAccountModel.IBAN:
                return maskIBAN(data.account_details.iban);
            case BankAccountModel.CLABE:
                return data.account_details.clabe_number || null;
            default:
                return null;
        }
    }, [data]);

    return <div className={classes.accountNumber}>{text}</div>;
};

AccountNumber.propTypes = {
    data: PropTypes.shape({
        account_type: PropTypes.oneOf(Object.values(BankAccountModel)).isRequired,
        account_details: PropTypes.object.isRequired
    }).isRequired
};
